import IconStar from '@fortuneo/ui-icons/general/IconStar'
import { clsx } from 'clsx'
import React from 'react'

type RatingItemProps = {
  filled: boolean
  size: number
  color: string
}

const RatingItem: React.FC<RatingItemProps> = ({ filled, size, color }) => {
  const fillColor = filled ? color : `${color}35`

  return (
    <div className="relative">
      <IconStar fill={fillColor} height={size} width={size} />
    </div>
  )
}

type RatingProps = {
  value: number
  count?: number
  color?: 'default' | 'green'
  className?: string
  size?: number
}

const Rating: React.FC<RatingProps> = ({
  value,
  count = 5,
  className = '',
  size = 20,
  color = 'default',
}) => {
  const filledColor = color === 'green' ? '#88C648' : '#232323'

  const ratingItems = Array.from({ length: count }).map((_, index) => {
    const filled = value >= index + 1
    const showRatingWithPrecision =
      value % 1 !== 0 && Math.ceil(value) === index + 1

    return (
      <div key={index}>
        <div
          className="absolute overflow-hidden"
          style={{
            width: showRatingWithPrecision ? `${(value % 1) * 100}%` : '0%',
          }}
        >
          <RatingItem filled color={filledColor} size={size} />
        </div>
        <RatingItem color={filledColor} filled={filled} size={size} />
      </div>
    )
  })

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <div className={clsx('relative flex gap-1 leading-none', className)}>
        {ratingItems}
      </div>
    </div>
  )
}

export default Rating
